// removed by extract-text-webpack-plugin
module.exports = {"fullscreen":"_3UD_RYNq23N9MDNymuPbof","container":"_2eGY4LcY3wDTYYywcqg916 _3UD_RYNq23N9MDNymuPbof"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/style.css
// module id = 543
// module chunks = 0